import { ConfigProvider, Input, Tooltip } from 'antd';
import { TextAreaProps } from 'antd/es/input';
import { FC, useState } from 'react';
import canSendSvg from './canSend.svg';
import conNotSendSvg from './canNotSend.svg';
import { omit, trim } from 'lodash-es';
import useI18n from '../../hooks/useI18n';
import loadingSvg from './loading.svg';
import zoomInSvg from './zoomIn.svg';
import zoomOutSvg from './zoomOut.svg';
import { useMount } from 'ahooks';

const { TextArea } = Input;

export interface IAutoSizeInputProps extends TextAreaProps {
  submit: () => Promise<void>;
  limitStatus: boolean;
  chatTotal: number;
  responding: boolean;
  isLogin: boolean;
  cancel: () => void;
}

export const AutoSizeInput: FC<IAutoSizeInputProps> = (props) => {
  const {
    disabled,
    submit,
    value,
    limitStatus,
    chatTotal,
    responding,
    isLogin,
    cancel,
  } = props;
  const canSubmit =
    !disabled && trim(value?.toString()).length > 0 && !limitStatus;
  const i18n = useI18n();

  const [expanded, setExpanded] = useState(false);

  useMount(() => {
    // 使用 ResizeObserver 监听 divA 的高度变化
    const autoSizeTextarea = document.getElementById('autoSizeTextarea');
    const expandButton = document.getElementById('expandButton');
    const targetHeight = 95; // 设置触发高度

    const resizeObserver = new ResizeObserver((entries) => {
      // 检查 divA 的高度
      if (expandButton) {
        for (let entry of entries) {
          if (entry.target.offsetHeight > targetHeight) {
            expandButton.style.display = 'block'; // 显示 B
          } else {
            expandButton.style.display = 'none'; // 隐藏 B
          }
        }
      }
    });

    // 开始监听 divA
    if (autoSizeTextarea) {
      resizeObserver.observe(autoSizeTextarea);
    }
  });
  return (
    <>
      <Tooltip
        title={
          limitStatus
            ? `${i18n('limitedTo')} ${chatTotal} ${i18n('timesPerDay')}`
            : ''
        }
      >
        <div
          className={`w-full bg-[#F2F4F8] rounded-[1.5rem] p-2 relative ${expanded ? 'h-[686px]' : ''}`}
        >
          <ConfigProvider
            theme={{
              token: {
                colorBgContainer: '#F2F4F8',
                colorBorder: '#F2F4F8',
                colorBgContainerDisabled: '#F2F4F8',
              },
              components: {
                Input: {
                  activeShadow: '#F2F4F8',
                  activeBorderColor: '#F2F4F8',
                  activeBg: '#F2F4F8',
                  hoverBorderColor: '#F2F4F8',
                  hoverBg: '#F2F4F8',
                },
              },
            }}
          >
            <TextArea
              {...omit(props, [
                'isLogin',
                'responding',
                'limitStatus',
                'chatTotal',
                'cancel',
                'submit',
              ])}
              disabled={disabled || limitStatus}
              id="autoSizeTextarea"
              onPressEnter={(e) => {
                if (!e.shiftKey && canSubmit) {
                  submit();
                  setExpanded(false);
                }
              }}
              placeholder={isLogin ? i18n('happy to answer') : i18n('for free')}
              autoSize={{ minRows: 1, maxRows: expanded ? 30 : 4 }}
              style={{
                width: 'calc(100% - 40px)',
                // margin: '0 20px'
              }}
            />
          </ConfigProvider>
          <div
            className={canSubmit ? "cursor-pointer" : "cursor-not-allowed"}
            onClick={() => setExpanded((pre) => !pre)}
          >
            <img
              src={expanded ? zoomInSvg : zoomOutSvg}
              className="absolute top-0 right-0 w-12 h-12"
              alt=""
              id="expandButton"
            />
          </div>
          <div
            className={canSubmit ? "cursor-pointer" : "cursor-not-allowed"}
            onClick={() => {
              if (canSubmit) {
                submit();
                setExpanded(false);
              }
              if (responding) {
                cancel();
              }
            }}
          >
            <img
              className="w-12 h-12 absolute bottom-0 right-0"
              src={
                responding ? loadingSvg : canSubmit ? canSendSvg : conNotSendSvg
              }
              alt=""
            />
          </div>
        </div>
      </Tooltip>

      <div className="w-full text-center my-3 text-xs text-[#04252b8f]">
        {i18n('AIGenerate')}
      </div>
    </>
  );
};
